import { Button, useMediaQuery } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";

export const CustomBtn = ({
  text,
  onClick,
  Icon,
  width,
  noMb,
  noMt,
  noIcon,
  disabled,
}) => {
  return (
    <Button
      type="submit"
      variant="contained"
      sx={{
        mt: noMt ? 0 : 2,
        mb: noMb ? 0 : 2,
        width: width ? width : "45%",
        height: "50px",
        backgroundColor: colors.primary,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textTransform: "none",
        borderRadius: "0px",
        "&:hover": {
          backgroundColor: colors.primary,
        },
        fontFamily: "Inter-SemiBold",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
      {!noIcon && <Icon sx={{ ml: 1 }} />}
    </Button>
  );
};

export const SecondaryBtn = ({
  text,
  onClick,
  Icon,
  width,
  padding,
  disabled,
  noMb,
  noMt,
  black,
  filled = false,
  noIcon = false,
  smallH,
}) => {
  const smallScreen = useMediaQuery("(max-width:960px)");
  return (
    <Button
      type="submit"
      sx={{
        mt: noMt ? 0 : 2,
        mb: noMb ? 0 : 2,
        width: width ? width : "45%",
        height: smallH ? smallH : "50px",
        backgroundColor: filled ? colors.primary : "transparent",
        border: `1px solid ${black ? colors.textColor : colors.primary}`,
        color: filled ? "#fff" : black ? colors.textColor : colors.primary,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textTransform: "none",
        borderRadius: "0px",
        "&:hover": {
          backgroundColor: filled ? "#fd666a" : "transparent",
        },
        fontFamily: "Inter-SemiBold",
        fontSize: smallScreen ? "12px" : "14px",
        gap: smallScreen ? 0.5 : 1,
        padding: padding,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
      {!noIcon && (
        <Icon
          sx={{
            color: filled ? "#fff" : black ? colors.textColor : colors.primary,
            fontSize: "20px",
          }}
        />
      )}
    </Button>
  );
};
